import { render, staticRenderFns } from "./ContestOfferSummaryView.vue?vue&type=template&id=18c0d4dc&scoped=true&"
import script from "./ContestOfferSummaryView.vue?vue&type=script&lang=js&"
export * from "./ContestOfferSummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0d4dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VFlex,VLayout})
